import { Checkbox, Divider, Stack, Typography } from '@mui/material';
import { PurchaseAgreement } from '@retail/purchase-agreements/types';

interface Props {
  agreement: PurchaseAgreement;
  selectedAgreementIds: number[];
  selectAgreement: (agreement: number) => void;
}

export function AgreementWithCheckbox({ agreement, selectedAgreementIds, selectAgreement }: Props) {
  return (
    <Stack key={agreement.id} flexDirection="row" alignItems="center">
      <Checkbox
        id={agreement.id + ''}
        checked={selectedAgreementIds.includes(agreement.id)}
        onClick={() => selectAgreement(agreement.id)}
      />
      <Stack
        sx={{ cursor: 'pointer' }}
        component="label"
        htmlFor={agreement.id + ''}
        flexGrow={1}
        flexDirection="row"
        alignItems="center"
        gap={2}
      >
        <Typography variant="subtitle2">{agreement.name}</Typography>
        <Divider orientation="vertical" flexItem />
        <Typography variant="body2">{agreement.id}</Typography>
      </Stack>
    </Stack>
  );
}
